import { Events, on } from './events.js';

function getSectionIdFromInner(el) {
  try {
    const wrap = el && el.closest && el.closest('[id^="shopify-section-"]');
    if (!wrap || !wrap.id) return null;
    return wrap.id.replace('shopify-section-', '');
  } catch (_) { return null; }
}

async function refreshSections(sectionIds) {
  if (!sectionIds || sectionIds.length === 0) return;
  const ids = Array.from(new Set(sectionIds.filter(Boolean)));
  if (ids.length === 0) return;
  try {
    // Use full current URL so existing query (e.g., ?page) is respected by the renderer
    const url = new URL(window.location && window.location.href ? window.location.href : '/');
    url.searchParams.set('sections', ids.join(','));
    const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
    const text = await res.text();
    let payload = null;
    try { payload = JSON.parse(text); } catch (_) { payload = null; }
    if (payload && typeof payload === 'object') {
      ids.forEach((id) => {
        try {
          const html = payload[id];
          if (!html) return;
          const curr = document.querySelector(`#shopify-section-${id}`);
          if (!curr) return;
          // Replace safely by parsing the returned HTML snippet
          const tpl = document.createElement('div');
          tpl.innerHTML = String(html);
          const next = tpl.firstElementChild;
          if (next) curr.replaceWith(next);
        } catch (_) {}
      });
      return;
    }
    // Fallback: if server returned raw HTML (e.g., using section_id), try to parse and swap
    try {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      ids.forEach((id) => {
        try {
          const next = doc.querySelector(`#shopify-section-${id}`);
          const curr = document.querySelector(`#shopify-section-${id}`);
          if (next && curr) curr.replaceWith(next);
        } catch (_) {}
      });
    } catch (_) {}
  } catch (_) {}
}

// Variant updates → refresh the closest product section (and optionally others)
on(Events.variant.update, (ev) => {
  try {
    const target = ev && ev.target ? ev.target : document.body;
    const sid = getSectionIdFromInner(target);
    if (sid) refreshSections([sid]);
  } catch (_) {}
});

// Cart updates → refresh cart section if present
on(Events.cart.added, () => {
  const cartWrap = document.querySelector('[id^="shopify-section-cart"], #shopify-section-cart');
  if (cartWrap) refreshSections(['cart']);
});
on(Events.cart.update, () => {
  const cartWrap = document.querySelector('[id^="shopify-section-cart"], #shopify-section-cart');
  if (cartWrap) refreshSections(['cart']);
});

try { window.store = window.store || {}; window.store.refreshSections = refreshSections; } catch (_) {}


